import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { MapService } from 'src/app/Services/map.service';
import { RouteService } from 'src/app/Services/route.service';
import { debounceTime } from 'rxjs/operators';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { group } from 'console';
declare const Swal;
declare var google: any;

@Component({
  selector: 'app-roster-grouping',
  templateUrl: './roster-grouping.component.html',
  styleUrls: ['./roster-grouping.component.css'],
})
export class RosterGroupingComponent implements OnInit {
  public branchInformation: any = {};
  public selectedBranch: any = [];
  public shiftInformation: any = [];
  public selectedTrip: any = ['Pickup', 'Drop'];
  public reOrderArr: any = [];
  selectedItem: string = 'adhoc';
  public addemployeesresponse:any={};
  public employeelist={
    "status": "success",
    "adhoc": [
        {
            "orgID": "667bb67d4320ee9cda2044cb",
            "status": 1,
            "tripDate": 1738866600000,
            "transitMode": "Drop",
            "empTripStatus": "reschedule",
            "empID": "673d6b18f75d92abae9fb730",
            "empRefID": "TCS-099",
            "checked":false,
            "name": "Vignesh  R",
            "branchID": "667bec471496d0a689a6c26c",
            "shiftTimeStr": "20:00",
            "empAdhocID": "67a4ae181c2dc769aa5782ae"
        }
    ],
    "reschedule": [
        {
            "orgID": "667bb67d4320ee9cda2044cb",
            "status": 1,
            "tripDate": 1738866600000,
            "transitMode": "Drop",
            "empTripStatus": "reschedule",
            "empID": "673d6b18f75d92abae9fb730",
            "empRefID": "TCS-099",
            "checked":false,
            "name": "paramesh k",
            "branchID": "667bec471496d0a689a6c26c",
            "shiftTimeStr": "20:00",
            "empAdhocID": "67a4ae181c2dc769aa5782ae"
        }
    ],
    "emps": [
        {
            "orgID": "667bb67d4320ee9cda2044cb",
            "status": 1,
            "tripDate": 1738866600000,
            "transitMode": "Drop",
            "empTripStatus": "reschedule",
            "empID": "673d6b18f75d92abae9fb730",
            "empRefID": "TCS-099",
            "checked":false,
            "name": "Ravi   R",
            "branchID": "667bec471496d0a689a6c26c",
            "shiftTimeStr": "20:00",
            "empAdhocID": "67a4ae181c2dc769aa5782ae"
        }
    ]
}

 

  items = [
    // { value: 'adhoc', label: 'Adhoc request' },
    // { value: 'reschedule', label: 'Reschedule request' }, // This will be selected by default
    // { value: 'employee', label: 'Employees' }
    { value: 'employee', label: 'Non-rostered Cab Users' }
  ];
  @Input() set isExcelUploaded(val: any) {
    if (val) {
      this.loadFilterForm();
      if (this.selFilteredDate == undefined) {
        this.getEmployeeList();
      } else {
        this.availShiftTimes = [];
        this.isFirstTime = true;
        this.storedData = [];
        this.getEmployeeList(this.selFilteredDate);
      }
    }
  }
  @Input() set filterDate(val: any) {
    if (val) {
      this.storedData = [];
      this.availShiftTimes = [];
      this.isFirstTime = true;
      this.loadFilterForm();
      this.selFilteredDate = val;
      this.selectedTrip = ['Pickup', 'Drop']
      this.getEmployeeList(val);
    }
  }
  @Input() set branchChoosen(val: any) {
    if (val) {
      this.getBranchList();
      this.choosenBranch = val;
      this.storedData = [];
      this.availShiftTimes = [];
      this.isFirstTime = true;
      this.loadFilterForm();
      this.selectedTrip = ['Pickup', 'Drop']
      if (this.selFilteredDate == undefined) {
        this.getEmployeeList();
      } else {
        this.getEmployeeList(this.selFilteredDate);
      }
    } else {
      this.choosenBranch = [];
    }
  }
  public empInformation: any = [];


  public orgID: string = '';
  public vendorID: string = '';
  public groupData: any = [];
  public allCheck: boolean = false;
  public allIndeterminate: boolean = false;
  public storedData: any = [];
  public storedRouteData: any = [];
  public availShiftTimes: any = [];
  public filterForm: FormGroup;
  public groupTableHeight: string = '60.5vh';
  public groupShift: number = 0;
  public groupEmps: number = 0;
  public routedEmps: number = 0;
  public listShifts: any = [];
  public allShifts: any = [];
  public isFirstTime: boolean = true;
  public selTransMode: string = '';
  public selTripDate: string = '';
  public selRoutingTripDate: string = '';
  public minDate: string;
  public selFilteredDate: number;
  public noData: string = 'No group found';


  public selectedMap: string = 'google';
  // public selectedMap:string='osrm';
  public googleMapObj: any;
  public locationMap: any;
  public markerId = 'pickLocation' + Math.round(Math.random() * 10000);
  public markersArray: any = [];

  public choosenBranch: any = [];
  public branchInfo: any = {};
  constructor(
    public storage: StorageService,
    public api: ApiService,
    public swal: SweetAlert,
    private com: CommonServices,
    private mapService: MapService,
    private routeservice: RouteService,
  ) {
    // let user= this.storage.get('userInfo');
    // if(user && user.map){
    //   this.selectedMap = user.map; 
    // }
    let today = new Date();
    this.minDate = this.formatDate(new Date(new Date().setDate(today.getDate() - 1)));
    this.orgID = this.storage.get('userInfo').orgID;
    if (this.storage.get('userInfo').branch && this.storage.get('userInfo').branch.length > 0) {
      this.selectedBranch = this.storage.get('userInfo').branch;
    }
    this.getBranchList();
  }

  public adhocResList: any = [];
  public reschedulecResList: any = [];
  public getadhoc_rescheduledate: any;
  public all_employeeslist: any = [];
  public selected_Value = '';
  filteredEmployees = [];
  transit_modes = [
    { value: 'pickup', label: 'Pickup' },
    { value: 'drop', label: 'Drop' },
    { value: 'both', label: 'Both' }
  ];
  public enable_emplist=true;

  ngOnInit(): void {
    this.loadFilterForm();
    // if(this.selFilteredDate==undefined){
    //   setTimeout(()=>{
    //     this.getEmployeeList();
    //   },1000)
    // }
    this.loadMap();
  }
  // getBranchList() {
  //   let data = {
  //     orgID: this.storage.get('userInfo').orgID
  //   };
  //   this.api.transportManagerBranchList(data).then((res: any) => {
  //     if (res && res.status == 'success' && res.data && res.data.length > 0) {
  //       for (let i = 0; i < res.data.length; i++) {
  //         this.branchInformation[res.data[i]['branchID']] = res.data[i]['branchName'];
  //       }
  //       if (this.selectedBranch == undefined || this.selectedBranch.length <= 0) {
  //         this.selectedBranch = Object.keys(this.branchInformation)
  //       }
  //       let reqArr = res.data.filter(e => e.branchID == this.choosenBranch)
  //       this.branchInfo = {
  //         name: reqArr[0].branchName,
  //         location: reqArr[0].location,
  //         branchID: reqArr[0].branchID
  //       }
  //     } else {
  //       this.selectedBranch = [];
  //       this.branchInformation = {};
  //     }
  //   }).catch((err) => {
  //     console.log(err);
  //   });
  // }

  // onchangeTransitmode(e:any){
  //   if(e=='pickup'|| e=='drop' || e=='both'){
  //     this.enable_emplist=false;

  //     if (this.selectedItem == "adhoc") {
  //       this.availableSearchEmps = this.addemployeesresponse.adhoc;
  //       //this.adhocEmps=this.addemployeesresponse.adhoc;
  //       //this.adhocEmps= this.removemultiplepropertiesDuplicates( this.adhocEmps);
  //     } else if (this.selectedItem == "reschedule") {
  //       this.availableSearchEmps = this.addemployeesresponse.reschedule;
  //       //this.adhocEmps=this.addemployeesresponse.reschedule;
  //     } else if (this.selectedItem == "employee") {
  //       this.availableSearchEmps = this.addemployeesresponse.emp;
  //       //this.adhocEmps=this.addemployeesresponse.emp;
  //     }
  //     else if (this.selectedItem == 'all') {
  
  //       this.availableSearchEmps = this.all_employeeslist;
  //       //this.adhocEmps=this.all_employeeslist;    
  //     }
      
  //     this.availableSearchEmps = this.availableSearchEmps.filter(item => ( item.transitMode === 'pickup' && this.selected_Value==='pickup' || item.transitMode === 'Pickup' && this.selected_Value==='pickup') || (item.transitMode === 'drop' && this.selected_Value==='drop' || item.transitMode === 'Drop' && this.selected_Value==='drop' )||(item.tripType === 'both' && this.selected_Value==='both')); 
      
     
  //   }else{
  //     this.enable_emplist=true;
  //     this.selectedItem="";
  //   }
    
  // }

public selectreschedulegroup_index:any;
 public rescheduleclick:boolean=false;
 public addrescheduleEmpData: any = [];
  Rescheduleedit(reqby:any,rosterID,routeID,empRefID,groupindex,childindex){
    if(reqby==='reschedule'){
      this.selectreschedulegroup_index=groupindex;
      this.rescheduleclick= true;
      this.addrescheduleEmpData.push(this.groupData[groupindex]['empInfo'][childindex]);
      //this.createGroupData.push(this.groupData[groupindex]['empInfo'][childindex]);
      this.openCreateEmployee();
      
    }

  }
  onchangeTransitmode(selectedMode: string) {
  this.selected_Value = selectedMode;  // ✅ make sure it's updated

  if (['pickup', 'drop', 'both'].includes(selectedMode)) {
    this.enable_emplist = false;

    // // choose employee list based on selectedItem
    // switch (this.selectedItem) {
    //   case 'adhoc':
    //     this.availableSearchEmps = this.addemployeesresponse?.adhoc || [];
    //     break;
    //   case 'reschedule':
    //     this.availableSearchEmps = this.addemployeesresponse?.reschedule || [];
    //     break;
    //   case 'employee':
    //     this.availableSearchEmps = this.addemployeesresponse?.emp || [];
    //     break;
    //   case 'all':
    //     this.availableSearchEmps = this.all_employeeslist || [];
    //     break;
    //   default:
    //     this.availableSearchEmps = [];
    // }

    // // ✅ Filter by selected mode
    // this.availableSearchEmps = this.availableSearchEmps.filter(item =>
    //   (['pickup', 'Pickup'].includes(item.transitMode) && selectedMode === 'pickup') ||
    //   (['drop', 'Drop'].includes(item.transitMode) && selectedMode === 'drop') ||
    //   (item.tripType === 'both' && selectedMode === 'both')
    // );

  } else {
    this.enable_emplist = true;
    this.selectedItem = '';
    this.availableSearchEmps = [];
  }
}


   getBranchList() {
    let data = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(data).then((res: any) => {
      if (res && res.status == 'success' && res.data && res.data.length > 0) {
        this.branchList = res.data.map((b: any) => ({
          branchID: b.branchID,
          branchName: b.branchName,
          location: b.location
        }));

        // still keep mapping
        this.branchInformation = {};
        res.data.forEach((b: any) => {
          this.branchInformation[b.branchID] = b.branchName;
        });
        let reqArr = res.data.filter(e => e.branchID == this.choosenBranch)
        this.branchInfo = {
          name: reqArr[0].branchName,
          location: reqArr[0].location,
          branchID: reqArr[0].branchID
        }
      } else {
        this.selectedBranch = [];
        this.branchInformation = {};
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  
  getTimeSlots(): string[] {
    let timeSlots: string[] = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute of [0, 30]) {
        let formattedHour = hour.toString().padStart(2, '0');
        let formattedMinute = minute.toString().padStart(2, '0');
        timeSlots.push(`${formattedHour}:${formattedMinute}`);
      }
    }
    return timeSlots;
  }

  getListShift() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.ListShift(obj).then((res: any) => {
      if (res && res.status == 'success' && res.data.length > 0) {
        let data = res.data;
        let arr = [];
        let shift = data.filter(e => e.branch == this.choosenBranch[0]);
        for (let j = 0; j < shift.length; j++) {
          arr.push(this.convertShiftTime(shift[j].startTime));
        }
        let shifts = this.removeDuplicateString(arr);
        this.shiftInformation = this.com.sortShifts(shifts);
      } else {
        this.shiftInformation = [];
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  convertShiftTime(time) {
    let arr = time.split(':');
    if (Number(arr[0]) < 10 && arr[0]) {
      arr[0] = '0' + arr[0];
    }
    let timeString = arr.join(':');
    return timeString;
  }
  loadFilterForm() {
    this.filterForm = new FormGroup({
      shiftTime: new FormControl('', [Validators.required]),
      empCount: new FormControl('', [Validators.required]),
    })
  }
  getEmployeeList(date?) {
    this.allCheck = false;
    this.allIndeterminate = false;
    this.finalAllCheck = false;
    this.finalAllIndeterminate = false;
    this.addEmpData = [];
    this.availableEmpInGroups = [];
    this.mergeGroupsData = {};
    this.groupData = [];
    this.finalizedData = [];
    this.selFinalEmp = [];
    this.selFinalGroups = {};
    this.selFinalGroupEmps = [];
    this.selTransMode = '';
    this.selTripDate = '';
    let apiObj = {
      shiftTimeStr: this.filterForm.value.shiftTime,
      empCount: Number(this.filterForm.value.empCount) > 0 ? Number(this.filterForm.value.empCount) : '',
      tripType: this.selectedTrip,
      rosterStatus: ['Grouping', 'Routing']
    }
    // if(this.selFilteredDate==undefined){
    //   apiObj['tripDate']=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
    // }else{
    //   apiObj['tripDate']=this.selFilteredDate;
    // }
    let currentDate = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
    if (this.selFilteredDate == undefined || this.selFilteredDate == currentDate) {
      apiObj['tripDate'] = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
      apiObj['istoday'] = true;
      this.getadhoc_rescheduledate= new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
    } else {
      apiObj['tripDate'] = this.selFilteredDate;
      apiObj['istoday'] = false;
      this.getadhoc_rescheduledate=this.selFilteredDate;
    }
    // if(this.storage.get('userInfo').userType!='admin'){
    // }

    apiObj['branchID'] = this.choosenBranch;

    this.api.transportManagerGrouping(apiObj).then(async (res: any) => {
      // this.enablePickupDrop();
      if (res && res.status == 'success') {
        console.log("roster res::::::::::::::", res);
        
        if (res.data[0]['grouping'] && res.data[0]['grouping'].length > 0) {
          this.groupEmps = 0;
          
          this.groupData = await this.com.sortDatesWithTime(res.data[0]['grouping'], 'tripDate');
          console.log("Group Data::::::", this.groupData );
          
          if (this.isFirstTime) {
            this.storedData = JSON.parse(JSON.stringify(res.data[0]['grouping']));
            let shiftArr = [];
            for (let i = 0; i < this.storedData.length; i++) {
              shiftArr.push(this.storedData[i]['shiftTimeStr']);
            }
            let shifts = this.removeDuplicateShifts(shiftArr);
            this.availShiftTimes = this.com.sortShifts(shifts);
            // this.availShiftTimes=this.removeDuplicateShifts(shiftArr);
          }
        } else {
          this.groupEmps = 0;
          this.groupData = [];
          if (this.isFirstTime) {
            this.availShiftTimes = [];
            this.storedData = [];
          }
        }
        if (res.data[0]['routing'] && res.data[0]['routing'].length > 0) {
          this.routedEmps = 0;
          this.finalizedData = await this.com.sortDatesWithTime(res.data[0]['routing'], 'tripDate');
          console.log("finalizedData Group Data::::::", this.finalizedData );
          if (this.isFirstTime) {
            this.storedRouteData = JSON.parse(JSON.stringify(res.data[0]['routing']));
          }
          let shiftArr = [];
          for (let i = 0; i < this.finalizedData.length; i++) {
            shiftArr.push(this.finalizedData[i]['shiftTimeStr']);
          }
          this.listShifts = this.removeDuplicateShifts(shiftArr);
          for (let i = 0; i < this.finalizedData.length; i++) {
            this.routedEmps += this.finalizedData[i]['empInfo'].length;
          }
          //Differentiate female emps
          for (let i = 0; i < this.finalizedData.length; i++) {
            let employeeInfo = this.finalizedData[i]['empInfo'];
            let allEmpFemale = false;
            for (let j = 0; j < employeeInfo.length; j++) {
              if (employeeInfo[j].gender == 'Male') {
                allEmpFemale = false;
                break;
              } else {
                allEmpFemale = true;
              }
            }
            // if (allEmpFemale) {
            //   this.finalizedData[i]['allFemale'] = true;
            // }
            if (allEmpFemale || employeeInfo.length == 1 && employeeInfo[employeeInfo.length - 1].gender == 'Female') {
              this.finalizedData[i]['allFemale'] = true;
              this.finalizedData[i]['firstFemale'] = false;
              this.finalizedData[i]['lastFemale'] = false;
            } else {
              if (employeeInfo[0].gender == 'Female' && (this.finalizedData[i].transitMode == 'pickup' || this.finalizedData[i].transitMode == 'Pickup')) {

                this.finalizedData[i]['allFemale'] = false;
                this.finalizedData[i]['firstFemale'] = true;
                this.finalizedData[i]['lastFemale'] = false;

              }
              else if (employeeInfo[employeeInfo.length - 1].gender == 'Female' && (this.finalizedData[i].transitMode == 'drop' || this.finalizedData[i].transitMode == 'Drop')) {
                this.finalizedData[i]['allFemale'] = false;
                this.finalizedData[i]['firstFemale'] = false;
                this.finalizedData[i]['lastFemale'] = true;
              }
            }
          }
        } else {
          this.listShifts = [];
          this.routedEmps = 0;
          this.finalizedData = [];
          this.storedRouteData = [];
        }
        this.isFirstTime = false;
        this.findAvailableShiftandEmpCount();
        //Differentiate female emps
        this.findFemaleEmployee();
        this.getAddEmpList();
        let shifts = [...this.availShiftTimes, ...this.listShifts];
        this.allShifts = this.removeDuplicateShifts(shifts);
      } else {
        this.disablePickupDrop();
        this.groupData = [];
        // this.storedData=[];
        // this.finalizedData=[];
        // this.storedRouteData=[];
        // this.allShifts=[];
      }
      // this.getListShift();
      this.shiftInformation=this.getTimeSlots();
    }).catch((err) => {
      this.disablePickupDrop();
      this.groupData = [];
      this.storedData = [];
      this.availShiftTimes = [];
      this.finalizedData = [];
      this.storedRouteData = [];
      this.allShifts = [];
      console.log(err);
    });
    this.disableAdd = true;
    this.disableCreate = true;
    this.disableMerge = true;
    this.disableMove = true;
    this.disableRemove = true;
    const obj = {
      orgID: this.storage.get('userInfo').orgID,
    };
  }

//   getAddEmpList() {
//     let apiObj = {
//       tripDate: this.getadhoc_rescheduledate,
//       branchID: this.choosenBranch[0],
//       // search:this.searchedValue
//     }
//     let currentDate = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
//     if (this.selFilteredDate == undefined || this.selFilteredDate == currentDate) {
//       apiObj['tripDate'] = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
//       apiObj['istoday'] = true;
//       this.getadhoc_rescheduledate= new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
//     } else {
//       apiObj['tripDate'] = this.selFilteredDate;
//       apiObj['istoday'] = false;
//       this.getadhoc_rescheduledate=this.selFilteredDate;
//     }
//     this.api.transportManagerGetEmployeeList(apiObj).then((res: any) =>
//     //this.api.transportManagerRosterAdhocEmployeeList(obj).then((res: any) => 
//     {
//       //if(res && res.status == 'success' && res.data && res.data.length>0)
// //       if (res && res.status == 'success') {

// //         // this.addemployeesresponse = res;
// //         // this.adhocResList = res.adhoc;
// //         // this.reschedulecResList=res.reschedule
// //         // this.adhocResList=res.data;
// //         // if(this.finalizedEmps.length<=0){
// //         //   this.adhocEmps=res.data;
// //         //   this.availableSearchEmps=this.adhocEmps;
// //         // }else{
// //         //   let data=[];
// //         //   for(let i=0;i<res.data.length;i++){
// //         //     let index=this.finalizedEmps.findIndex(e=>e.empRefID==res.data[i].empRefID && e.tripType==res.data[i].transitMode);
// //         //     if(index==-1){
// //         //       data.push(res.data[i]);
// //         //     }
// //         //   }
// //         //   this.adhocEmps=data;
// //         //   this.availableSearchEmps=this.adhocEmps;
// //         // }

// // //         if (this.finalizedEmps.length <= 0) {
// // //  // Initialize employee arrays
// // //           this.all_employeeslist = [];
          
// // //           // Set adhocEmps based on selectedItem
// // //           if (this.selectedItem == 'adhoc' && this.addemployeesresponse.adhoc) {
// // //             this.adhocEmps = this.addemployeesresponse.adhoc || [];
// // //           } else if (this.selectedItem == 'reschedule' && this.addemployeesresponse.reschedule) {
// // //             this.adhocEmps = this.addemployeesresponse.reschedule || [];
// // //           } else if (this.selectedItem == 'employee' && this.addemployeesresponse.emp) {
// // //             this.adhocEmps = this.addemployeesresponse.emp || [];
// // //           } else {
// // //             // Default to adhoc if selectedItem is not set or data not available
// // //             this.adhocEmps = this.addemployeesresponse.adhoc || [];
// // //             this.selectedItem = 'adhoc';
// // //           }

// // //           // if (this.selectedItem == 'adhoc') {
// // //           //   this.adhocEmps = this.addemployeesresponse.adhoc;
// // //           //   // this.adhocEmps=this.removemultiplepropertiesDuplicates(this.addemployeesresponse.adhoc);
// // //           // }
// // //           // if(this.selectedItem=='reschedule'){
// // //           //   this.adhocEmps =this.addemployeesresponse.reschedule;

// // //           // } if(this.selectedItem=='employee'){
// // //           //   this.adhocEmps = this.addemployeesresponse.emp;

// // //           // }
// // //           // else {
// // //           if (this.addemployeesresponse.adhoc && this.addemployeesresponse.adhoc.length > 0) {
// // //             for (let i = 0; i < this.addemployeesresponse.adhoc.length; i++) {
// // //               this.all_employeeslist.push(this.addemployeesresponse.adhoc[i]);
// // //             }

// // //           }
// // //           if (this.addemployeesresponse.reschedule && this.addemployeesresponse.reschedule.length > 0) {
// // //           // if (this.addemployeesresponse.reschedule.length > 0) {
// // //             for (let i = 0; i < this.addemployeesresponse.reschedule.length; i++) {
// // //               this.all_employeeslist.push(this.addemployeesresponse.reschedule[i]);
// // //             }

// // //           }
// // //           if (this.addemployeesresponse.emp && this.addemployeesresponse.emp.length > 0) {
// // //             for (let i = 0; i < this.addemployeesresponse.emp.length; i++) {
// // //               this.all_employeeslist.push(this.addemployeesresponse.emp[i]);
// // //             }

// // //             // }
// // //             // let uniqueEmployees = this.removemultiplepropertiesDuplicates(this.all_employeeslist);

// // //             //this.all_employeeslist=uniqueEmployees;

// // //             //this.adhocEmps=this.all_employeeslist;

// // //           }
// // //           this.availableSearchEmps = this.adhocEmps;

          

// // //         } else {

         
// // //           let data = [];
// // //           let empresponse: any = []

// // //           if (this.selectedItem == 'adhoc') {
// // //             empresponse = this.addemployeesresponse.adhoc;

// // //           } else if (this.selectedItem == 'reschedule') {
// // //             empresponse = this.addemployeesresponse.reschedule;

// // //           } else if (this.selectedItem == 'employee') {
// // //             empresponse = this.addemployeesresponse.emp;

// // //           } else if (this.selectedItem == 'all') {
// // //             empresponse = this.all_employeeslist;
// // //           }

// // //           for (let i = 0; i < empresponse.length; i++) {
// // //             let index;
// // //             if (empresponse[i].reqType && empresponse[i].reqType == 'employee_request') {
// // //               index = this.finalizedEmps.findIndex(e => e.empRefID == empresponse[i].empRefID && e.tripType === empresponse[i].tripType);


// // //             } else if ((empresponse[i].reqType && empresponse[i].reqType == 'adhoc_request') || (empresponse[i].reqType && empresponse[i].reqType == 'reschedule_request')) {
// // //               index = this.finalizedEmps.findIndex(e => e.empRefID == empresponse[i].empRefID && e.tripType == empresponse[i].transitMode);
// // //               for (let j = 0; j < this.finalizedEmps.length; j++) {
// // //                 if (this.finalizedEmps[j].tripType == 'pickup' && this.finalizedEmps[j].employeeID == empresponse[i].employeeID) {
// // //                   if (empresponse[i].transitMode == 'drop') {
// // //                     empresponse[i]['disabled'] = true;
// // //                   }


// // //                 } else if (this.finalizedEmps[j].tripType == 'drop' && this.finalizedEmps[j].employeeID == empresponse[i].employeeID) {
// // //                   if (empresponse[i].transitMode == 'pickup') {
// // //                     empresponse[i]['disabled'] = true;
// // //                   }
// // //                 }

// // //               }



// // //             }
// // //             if (index == -1) {
// // //               data.push(empresponse[i]);
// // //             }
// // //           }
// // //           this.adhocEmps = data;
// // //           this.availableSearchEmps = this.adhocEmps;
// // //         }

// //         // if(this.selected_Value!=null){
// //         //   this.availableSearchEmps = this.availableSearchEmps.filter(item =>(item.transitMode === 'pickup' && this.selected_Value==='pickup' || item.transitMode === 'Pickup' && this.selected_Value==='pickup') || (item.transitMode === 'drop' && this.selected_Value==='drop' || item.transitMode === 'Drop' && this.selected_Value==='drop' )||(item.tripType === 'both' && this.selected_Value==='both'));   
// //         // }
// // this.availableSearchEmps = res.data || [];
// //   this.filteredEmployees = this.availableSearchEmps;
// //         this.filteredEmployees=this.availableSearchEmps;
// //         this.adhocResList = res.adhoc || [];
// //   this.reschedulecResList = res.reschedule || [];

// //         // this.filteredEmployees=this.availableSearchEmps;
// //          // Extract unique areas from employee data for the area dropdown
// //         // let allAreas = [];
// //         // Function to recursively extract areas from any object/array
// //         // const extractAreas = (obj) => {
// //         //   if (Array.isArray(obj)) {
// //         //     obj.forEach(item => extractAreas(item));
// //         //   } else if (obj && typeof obj === 'object') {
// //         //     if (obj.area) {
// //         //       allAreas.push(obj.area);
// //         //     }
// //         //     Object.values(obj).forEach(value => {
// //         //       if (typeof value === 'object') {
// //         //         extractAreas(value);
// //         //       }
// //         //     });
// //         //   }
// //         // }
// //         //     extractAreas(this.addemployeesresponse);
// //         // console.log('addemployeesresponse:', this.addemployeesresponse);
// //         // if (this.addemployeesresponse.adhoc && this.addemployeesresponse.adhoc.length > 0) {
          
// //         //   for (let emp of this.addemployeesresponse.adhoc) {
            
// //         //     if (emp.area) allAreas.push(emp.area);
// //         //   }
// //         // }
// //         // if (this.addemployeesresponse.reschedule && this.addemployeesresponse.reschedule.length > 0) {
          
// //         //   for (let emp of this.addemployeesresponse.reschedule) {
            
// //         //     if (emp.area) allAreas.push(emp.area);
// //         //   }
// //         // }
// //         // if (this.addemployeesresponse.emp && this.addemployeesresponse.emp.length > 0) {
          
// //         //   for (let emp of this.addemployeesresponse.emp) {
            
// //         //     if (emp.area) allAreas.push(emp.area);
// //         //   }
// //         // }
        
// //         // console.log('All areas found:', allAreas);
// //         // Remove duplicates and update finalizedEmpArea for the dropdown
// //         // this.finalizedEmpArea = this.removeDuplicateString(allAreas);
// //       } else {
// //         this.adhocResList = [];
// //         this.adhocEmps = [];
// //         this.availableSearchEmps = [];
// //          this.finalizedEmpArea = [];
// //       }
// if (res && res.status == 'success') {
//   this.addemployeesresponse = res;

//   // 🔹 Use the API’s full data (all employees together)
//   this.adhocEmps = res.data || [];
//   this.availableSearchEmps = res.data || [];
//   this.filteredEmployees = this.availableSearchEmps;

//   // If you still want to filter later by adhoc/reschedule/employee
//   this.adhocResList = res.adhoc || [];
//   this.reschedulecResList = res.reschedule || [];
// } else {
//   this.adhocResList = [];
//   this.adhocEmps = [];
//   this.availableSearchEmps = [];
// }
//     }).catch((err) => {
//       console.log(err);
//     });
//   }

getAddEmpList() {
  let apiObj = {
    tripDate: this.getadhoc_rescheduledate,
    branchID: this.choosenBranch[0],
  };
  this.api.transportManagerGetEmployeeList(apiObj).then((res: any) => {
    if (res && res.status === 'success') {
      // 🔹 Assign API response employees directly
      this.addemployeesresponse = res;
      console.log("addemployeesresponse::::::::::::::", res);
      this.adhocEmps = res.data;
      this.availableSearchEmps = res.data;
      console.log("availableSearchEmps:::::::::", this.availableSearchEmps);
      
      this.filteredEmployees = res.data;

      // 🔹 If finalizedEmps exists, filter them out
      if (this.finalizedEmps.length > 0) {
        this.availableSearchEmps = res.data.filter(emp =>
          !this.finalizedEmps.some(finalized =>
            finalized.empRefID === emp.empRefID &&
            (finalized.tripType === emp.tripType || finalized.tripType === emp.transitMode)
          )
        );
        this.adhocEmps = this.availableSearchEmps;
        this.filteredEmployees = this.availableSearchEmps;
      }

      // 🔹 If transitMode filter is selected
      // if (this.selected_Value) {
      //   this.availableSearchEmps = this.availableSearchEmps.filter(item =>
      //     (item.transitMode?.toLowerCase() === this.selected_Value.toLowerCase()) ||
      //     (item.tripType === 'both' && this.selected_Value === 'both')
      //   );
      //   this.adhocEmps = this.availableSearchEmps;
      //   this.filteredEmployees = this.availableSearchEmps;
      // }

              let allAreas = [];
        // Function to recursively extract areas from any object/array
        const extractAreas = (obj) => {
          if (Array.isArray(obj)) {
            obj.forEach(item => extractAreas(item));
          } else if (obj && typeof obj === 'object') {
            if (obj.area) {
              allAreas.push(obj.area);
            }
            Object.values(obj).forEach(value => {
              if (typeof value === 'object') {
                extractAreas(value);
              }
            });
          }
        }
            extractAreas(this.addemployeesresponse);
        console.log('addemployeesresponse:', this.addemployeesresponse);
this.finalizedEmpArea = this.removeDuplicateString(allAreas);
    } else {
      this.adhocEmps = [];
      this.availableSearchEmps = [];
      this.filteredEmployees = [];
    }
  }).catch((err) => {
    console.log("API error:", err);
  });
}

  findAvailableShiftandEmpCount() {
    this.allCheck = false;
    this.allIndeterminate = false;
    this.selectAllGroup(false);
    this.groupEmps = 0;
    this.groupShift = 0;
    if (this.groupData.length > 0) {
      let shiftArr = [];
      for (let i = 0; i < this.groupData.length; i++) {
        shiftArr.push(this.groupData[i]['shiftTimeStr']);
      }
      let arr = this.removeDuplicateShifts(shiftArr);
      this.groupShift = arr.length;
      for (let i = 0; i < this.groupData.length; i++) {
        this.groupEmps += this.groupData[i]['empInfo'].length;
      }
    } else {
      this.groupEmps = 0;
      this.groupShift = 0;
    }
  }
  findFemaleEmployee() {
    for (let i = 0; i < this.groupData.length; i++) {
      let employeeInfo = this.groupData[i]['empInfo'];
      let allEmpFemale = false;
      for (let j = 0; j < employeeInfo.length; j++) {
        if (employeeInfo[j].gender == 'Male') {
          allEmpFemale = false;
          break;
        } else {
          allEmpFemale = true;
        }
      }
      if (allEmpFemale || employeeInfo.length == 1 && employeeInfo[employeeInfo.length - 1].gender == 'Female') {
        this.groupData[i]['allFemale'] = true;
        this.groupData[i]['firstFemale'] = false;
        this.groupData[i]['lastFemale'] = false;
      } else {
        if (employeeInfo[0].gender == 'Female' && (this.groupData[i].transitMode == 'pickup' || this.groupData[i].transitMode == 'Pickup' || this.groupData[i].transitMode == 'drop' || this.groupData[i].transitMode == 'Drop')) {

          this.groupData[i]['allFemale'] = false;
          this.groupData[i]['firstFemale'] = true;
          this.groupData[i]['lastFemale'] = false;

        }
        else if (employeeInfo[employeeInfo.length - 1].gender == 'Female' && (this.groupData[i].transitMode == 'drop' || this.groupData[i].transitMode == 'Drop' || this.groupData[i].transitMode == 'pickup' || this.groupData[i].transitMode == 'Pickup')) {
          this.groupData[i]['allFemale'] = false;
          this.groupData[i]['firstFemale'] = false;
          this.groupData[i]['lastFemale'] = true;
        }
      }
    }
  }
  filterChange(value, type) {
    this.allCheck = false;
    this.allIndeterminate = false;
    this.selectAllGroup(false);

    if (this.selFilteredDate == undefined) {
      this.getEmployeeList();
    } else {
      this.getEmployeeList(this.selFilteredDate);
    }
    // this.finalAllCheck=false;
    // this.finalAllIndeterminate=false;
    // this.selectAllFinalGroup(false);
    // if(type=='shift'){
    //   this.filterForm.controls['empCount'].patchValue('');
    //   if(value!=''){
    //     this.getEmployeeList(value);
    //   }else{
    //     this.getEmployeeList();
    //   }
    // }else{
    //   this.filterForm.controls['shiftTime'].patchValue('');
    //   if(value!=''){
    //     if(value!=7){
    //       this.groupData=this.storedData.filter(e=>e.empInfo.length==value);
    //     }else{
    //       this.groupData=this.storedData.filter(e=>e.empInfo.length>=value);
    //     }
    //   }else{
    //     this.groupData=this.storedData;
    //   }
    //   this.findFemaleEmployee();
    //   this.findAvailableShiftandEmpCount();
    // }
  }
  removeDuplicateShifts(arr) {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  }
  selectAllGroup(event) {
    this.groupTableHeight = '60.5vh';
    this.allCheck = event;
    this.allIndeterminate = false;
    for (let i = 0; i < this.groupData.length; i++) {
      this.groupData[i].checked = event;
      this.groupData[i].indeterminate = false;
      if (this.groupData[i].empInfo && this.groupData[i].empInfo.length > 0) {
        let data = this.groupData[i];
        this.selectGroup(event, data.rosterID, data.routeID, i);
      }
    }

  }
  selectGroup(event, rosterId, routeID, index) {
    //merge
    if (event) {
      let data = {};
      data[rosterId] = this.groupData[index].empInfo;

      this.mergeGroupsData = {
        ...this.mergeGroupsData,
        ...data
      }
    } else {
      delete this.mergeGroupsData[rosterId];
    }

    this.groupTableHeight = '60.5vh';
    this.groupData[index]['checked'] = event;
    this.groupData[index]['indeterminate'] = false;
    if (this.groupData[index]['empInfo'] && this.groupData[index]['empInfo'].length > 0) {
      let employee = this.groupData[index]['empInfo'];
      for (let i = 0; i < employee.length; i++) {
        employee[i].checked = event;
        employee[i].oldRosterID = rosterId;
        employee[i].routeID = routeID;
      }
      //For Add and Create
      if (event) {
        let arr1 = [...this.addEmpData, ...employee];
        this.addEmpData = this.removeDuplicates(arr1, 'empRefID');
        this.createGroupData = this.removeDuplicates(arr1, 'empRefID');
        let arr2 = [...this.availableEmpInGroups, ...employee];
        this.availableEmpInGroups = this.removeDuplicates(arr2, 'empRefID');
      } else {
        for (let k = 0; k < employee.length; k++) {
          let index = this.addEmpData.findIndex(e => e.empRefID == employee[k].empRefID);
          if (index != -1) {
            this.addEmpData.splice(index, 1);
            this.createGroupData.splice(index, 1);
          }
          let index2 = this.availableEmpInGroups.findIndex(e => e.empRefID == employee[k].empRefID);
          if (index2 != -1) {
            this.availableEmpInGroups.splice(index2, 1);
          }
        }
      }
    }
    this.checkAllGroupChecked();
  }
  selectEmployee(event, rosterId, routeID, empId, i) {
    this.groupTableHeight = '60.5vh';
    let index = this.groupData[i]['empInfo'].findIndex(e => e.empRefID == empId);
    if (index != -1) {
      this.groupData[i]['empInfo'][index].checked = event;
      this.groupData[i]['empInfo'][index].oldRosterID = rosterId;
      this.groupData[i]['empInfo'][index].routeID = routeID;
    }
    if (event) {
      this.addEmpData.push(this.groupData[i]['empInfo'][index]);
      this.createGroupData.push(this.groupData[i]['empInfo'][index]);
    } else {
      let empIndex = this.addEmpData.findIndex(e => e.empRefID == empId);
      if (empIndex != -1) {
        this.addEmpData.splice(empIndex, 1);
        this.createGroupData.splice(empIndex, 1);
      }
    }
    this.checkAllEmployeeChecked(event, rosterId, i);
    this.checkAllGroupChecked();
  }
  disableCheckBoxByClick(key, key2) {
    this.selTransMode = '';
    this.selTripDate = '';
    let arr = [];
    for (let i = 0; i < this.groupData.length; i++) {
      if (this.groupData[i].checked || this.groupData[i].indeterminate) {
        let index = arr.findIndex(e => e == this.groupData[i][key]);
        let index2 = arr.findIndex(e => e == this.groupData[i][key2]);
        if (index == -1) arr.push(this.groupData[i][key]);
        if (index2 == -1) arr.push(this.groupData[i][key2]);
      }
    }
    if (key == 'transitMode') {
      if (arr.length > 1) {
        this.selTransMode = arr[0];
      } else {
        this.selTransMode = '';
      }
    }
    if (key2 == 'tripDate') {
      if (arr.length > 1) {
        this.selTripDate = arr[1];
      } else {
        this.selTripDate = '';
      }
    }
  }
  checkAllEmployeeChecked(event, rosterId, index) {
    let employee = this.groupData[index]['empInfo'];
    let isValid = true;
    for (let i = 0; i < employee.length; i++) {
      if (employee[i].checked == false || employee[i].checked == undefined) {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    if (isValid) {
      this.groupData[index].checked = isValid;
      this.groupData[index].indeterminate = !isValid;

      let arr2 = [...this.availableEmpInGroups, ...employee];
      this.availableEmpInGroups = this.removeDuplicates(arr2, 'empRefID');

      //Merge
      let data = {};
      data[rosterId] = this.groupData[index].empInfo;

      this.mergeGroupsData = {
        ...this.mergeGroupsData,
        ...data
      }
    } else {
      for (let k = 0; k < employee.length; k++) {
        let index2 = this.availableEmpInGroups.findIndex(e => e.empRefID == employee[k].empRefID);
        if (index2 != -1) {
          this.availableEmpInGroups.splice(index2, 1);
        }
      }
      //Merge
      delete this.mergeGroupsData[rosterId];

      let checkArr = [];
      let indeterArr = [];
      for (let i = 0; i < employee.length; i++) {
        if (employee[i].checked) {
          checkArr.push('checked');
        } else if (employee[i].indeterminate) {
          indeterArr.push('indeterminate');
        }
      }
      let group = this.groupData[index];
      if (checkArr.length <= 0 && indeterArr.length <= 0) {
        group.indeterminate = isValid;
        group.checked = isValid;
      } else if (checkArr.length == employee.length) {
        group.checked = !isValid;
        group.indeterminate = isValid;
      } else if (indeterArr.length == employee.length) {
        group.indeterminate = !isValid;
        group.checked = isValid;
      } else {
        group.indeterminate = !isValid;
        group.checked = isValid;
      }
    }
    this.disableCheckBoxByClick('transitMode', 'tripDate');
    if (this.addEmpData.length > 0 && Object.keys(this.mergeGroupsData).length <= 0 && (this.selTransMode != '' || this.selTripDate != '')) {
      this.disableCreate = false;
    } else {
      this.disableCreate = true;
    }
    if (this.addEmpData.length != this.availableEmpInGroups.length && Object.keys(this.mergeGroupsData).length == 1 && (this.selTransMode != '' || this.selTripDate != '')) {
      this.disableAdd = false;
    } else {
      this.disableAdd = true;
    }
    // if((this.addEmpData.length != this.availableEmpInGroups.length && Object.keys(this.mergeGroupsData).length>1) 
    // || Object.keys(this.mergeGroupsData).length>1){
    //   this.disableMerge=false;
    // }else{
    //   this.disableMerge=true;
    // }
    if (Object.keys(this.mergeGroupsData).length > 1) {
      let groups = Object.keys(this.mergeGroupsData);
      let empArr = [];
      for (let i = 0; i < groups.length; i++) {
        empArr = [...empArr, ...this.mergeGroupsData[groups[i]]];
      }
      let allEmp = [];
      for (let a = 0; a < this.addEmpData.length; a++) {
        for (let b = 0; b < empArr.length; b++) {
          if (this.addEmpData[a].empRefID == empArr[b].empRefID) {
            allEmp.push(this.addEmpData[a]);
          }
        }
      }
      var is_same = this.addEmpData.length == allEmp.length && this.addEmpData.every(function (element, index) {
        return element['empRefID'] === allEmp[index]['empRefID'];
      })
      if (is_same && (this.selTransMode != '' || this.selTripDate != '')) {
        this.disableMerge = false;
      } else {
        this.disableMerge = true;
      }
    } else {
      this.disableMerge = true;
    }
    if (this.addEmpData.length == this.availableEmpInGroups.length && Object.keys(this.mergeGroupsData).length > 0) {
      this.disableMove = false;
    } else {
      this.disableMove = true;
    }
  }

  checkAllGroupChecked() {
    let isValid = true;
    for (let i = 0; i < this.groupData.length; i++) {
      if (this.groupData[i].checked == false || this.groupData[i].checked == undefined) {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    if (isValid) {
      this.allCheck = isValid;
      this.allIndeterminate = !isValid;
    } else {
      let checkArr = [];
      let indeterArr = [];
      for (let i = 0; i < this.groupData.length; i++) {
        if (this.groupData[i].checked) {
          checkArr.push('checked');
        } else if (this.groupData[i].indeterminate) {
          indeterArr.push('indeterminate');
        }
      }
      if (checkArr.length <= 0 && indeterArr.length <= 0) {
        this.allCheck = isValid;
        this.allIndeterminate = isValid;
      } else if (checkArr.length == this.groupData.length) {
        this.allCheck = !isValid;
        this.allIndeterminate = isValid;
      } else if (indeterArr.length == this.groupData.length) {
        this.allCheck = isValid;
        this.allIndeterminate = !isValid;
      } else {
        this.allCheck = isValid;
        this.allIndeterminate = !isValid;
      }
    }
    this.disableCheckBoxByClick('transitMode', 'tripDate');
    if (this.addEmpData.length > 0 && Object.keys(this.mergeGroupsData).length <= 0 && (this.selTransMode != '' || this.selTripDate != '')) {
      this.disableCreate = false;
    } else {
      this.disableCreate = true;
    }
    if (this.addEmpData.length != this.availableEmpInGroups.length && Object.keys(this.mergeGroupsData).length == 1 && (this.selTransMode != '' || this.selTripDate != '')) {
      this.disableAdd = false;
    } else {
      this.disableAdd = true;
    }
    // if((this.addEmpData.length != this.availableEmpInGroups.length && Object.keys(this.mergeGroupsData).length>1) 
    // || Object.keys(this.mergeGroupsData).length>1){
    //   this.disableMerge=false;
    // }else{
    //   this.disableMerge=true;
    // }

    if (Object.keys(this.mergeGroupsData).length > 1) {
      let groups = Object.keys(this.mergeGroupsData);
      let empArr = [];
      for (let i = 0; i < groups.length; i++) {
        empArr = [...empArr, ...this.mergeGroupsData[groups[i]]];
      }
      let allEmp = [];
      for (let a = 0; a < this.addEmpData.length; a++) {
        for (let b = 0; b < empArr.length; b++) {
          if (this.addEmpData[a].empRefID == empArr[b].empRefID) {
            allEmp.push(this.addEmpData[a]);
          }
        }
      }
      var is_same = this.addEmpData.length == allEmp.length && this.addEmpData.every(function (element, index) {
        return element['empRefID'] === allEmp[index]['empRefID'];
      })
      if (is_same && (this.selTransMode != '' || this.selTripDate != '')) {
        this.disableMerge = false;
      } else {
        this.disableMerge = true;
      }
    } else {
      this.disableMerge = true;
    }
    if (this.addEmpData.length == this.availableEmpInGroups.length && Object.keys(this.mergeGroupsData).length > 0) {
      this.disableMove = false;
    } else {
      this.disableMove = true;
    }
  }
  //Merge
  public mergeGroupsData: any = {};
  public disableMerge: boolean = true;
  public mergeGroupForm: FormGroup;
  public mergeDataAreas: any = {};
  public showMergeForm: boolean = false;
  public mergeEmployees: any = [];
  public mergeFormSubmitted: boolean = false;
  public disableEmployee: boolean = false;
  public availableEmpInGroups: any = [];
  public availMergeShifts: any = [];
  mergeGroups() {
    this.availMergeShifts = [];
    this.showMergeForm = true;
    document.getElementById('openMergeModalBtn')?.click();
    this.mergeFormLoad();
    this.mergeDataAreas = {};
    let rosterIds = Object.keys(this.mergeGroupsData);
    let arr = [];
    for (let i = 0; i < rosterIds.length; i++) {
      let index = this.groupData.findIndex(e => e.rosterID == rosterIds[i]);
      arr.push(this.groupData[index].shiftTimeStr);
      this.mergeDataAreas[this.groupData[index].area] = rosterIds[i];
    }
    let shifts = this.removeDuplicateString(arr);
    this.availMergeShifts = this.com.sortShifts(shifts);
    if (this.availMergeShifts.length == 1) {
      this.mergeGroupForm.controls['shiftTime'].patchValue(this.availMergeShifts[0]);
    }
  }
  mergeFormLoad() {
    this.mergeGroupForm = new FormGroup({
      tripDate: new FormControl(this.com.timestampToDate(this.selTripDate, 'YMD', '-'), [Validators.required]),
      shiftTime: new FormControl('', [Validators.required]),
      area: new FormControl('', [Validators.required]),
    })
  }
  public mergeCheckError = (controlName: string, errorName: string) => {
    return this.mergeGroupForm.controls[controlName].hasError(errorName);
  }

  closeMerge() {
    this.mergeDataAreas = {};
    this.showMergeForm = false;
    this.mergeFormSubmitted = false;
  }
  submitMerge() {
    this.mergeFormSubmitted = true;
    if (this.mergeGroupForm.valid) {
      //API call
      let rosterIds = Object.keys(this.mergeGroupsData);
      let rosterIndex = rosterIds.findIndex(e => e == this.mergeGroupForm.value.area);
      if (rosterIndex != -1) {
        rosterIds.splice(rosterIndex, 1);
      }

      let obj = {
        tripDate: new Date(this.mergeGroupForm.value.tripDate).getTime(),
        // "tripDate":1683916200000,
        shiftTimeStr: this.mergeGroupForm.value.shiftTime,
        // shiftTimeStr:'17:00',
        rosterID: this.mergeGroupForm.value.area,
        type: 'Merge',
        oldRosterID: rosterIds,
        empInfo: this.addEmpData,
        routeID: this.addEmpData[0].routeID,
        branchInfo: this.branchInfo
      }
      this.api.transportManagerEditGrouping(obj).then((res: any) => {
        if (res && res.status == 'success') {
          this.swal.swalFunction('success', res.status, res.message, 5000);
          this.mergeGroupsData = {};
          this.mergeDataAreas = {};
          document.getElementById('closeMergeBtn')?.click();
          this.groupData = [];
          this.addEmpData = [];
          this.availableEmpInGroups = [];
          this.closeMerge();
          this.closeAddEmpForm();
          this.closeCreateEmpForm();
          if (this.selFilteredDate == undefined) {
            this.getEmployeeList();
          } else {
            this.getEmployeeList(this.selFilteredDate);
          }
          this.finalAllCheck = false;
          this.finalAllIndeterminate = false;
          this.selectAllFinalGroup(false);
          this.enablePickupDrop();
          this.filterForm.controls['empCount'].patchValue('');
          this.filterForm.controls['shiftTime'].patchValue('');
        } else {
          this.swal.swalFunction('error', res.status, res.message, 5000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  //Add
  public addEmpData: any = [];
  public disableAdd: boolean = true;
  public showAddForm: boolean = false;
  public addEmpForm: FormGroup;
  public addFormSubmitted: boolean = false;
  public addEmpArea: any = {};
  public addEmpShift: any = '';
  addEmployee() {
    this.addEmpFormLoad();
    document.getElementById('openAddModalBtn')?.click();
    // this.addEmpForm.controls['area'].patchValue(this.addEmpArea);
    this.showAddForm = true;
    this.addEmpArea = {};
    let rosterIds = Object.keys(this.mergeGroupsData);
    for (let i = 0; i < rosterIds.length; i++) {
      let index = this.groupData.findIndex(e => e.rosterID == rosterIds[i]);
      if (index != -1) {
        this.addEmpArea[rosterIds[i]] = this.groupData[index].area;
        this.addEmpShift = this.groupData[index].shiftTimeStr;
      }
      this.addEmpForm.controls['area'].patchValue(rosterIds[i]);
    }
    this.addEmpForm.controls['shiftTime'].patchValue(this.addEmpShift);
    // this.addEmpArea=this.mergeGroupsData[groups[0]].area;
  }
  addEmpFormLoad() {
    this.addEmpForm = new FormGroup({
      tripDate: new FormControl(this.com.timestampToDate(this.selTripDate, 'YMD', '-'), [Validators.required]),
      shiftTime: new FormControl('', [Validators.required]),
      area: new FormControl('', [Validators.required]),
    })
  }
  public addCheckError = (controlName: string, errorName: string) => {
    return this.addEmpForm.controls[controlName].hasError(errorName);
  }
  submitAddEmployee() {
    this.addFormSubmitted = true;
    if (this.addEmpForm.valid) {
      let obj = {
        type: 'Add',
        tripDate: new Date(this.addEmpForm.value.tripDate).getTime(),
        shiftTimeStr: this.addEmpForm.value.shiftTime,
        // "tripDate":1683916200000,
        // shiftTimeStr:'17:00',
        rosterID: this.addEmpForm.value.area,
        empInfo: this.addEmpData,
        tripType: this.addEmpData[0].tripType,
        routeID: this.addEmpData[0].routeID,
        branchInfo: this.branchInfo
      }
      this.api.transportManagerEditGrouping(obj).then((res: any) => {
        if (res && res.status == 'success') {
          this.swal.swalFunction('success', res.status, res.message, 5000);
          this.mergeGroupsData = {};
          this.mergeDataAreas = {};
          document.getElementById('closeAddBtn')?.click();
          this.groupData = [];
          this.addEmpData = [];
          this.availableEmpInGroups = [];
          this.closeMerge();
          this.closeAddEmpForm();
          this.closeCreateEmpForm();
          if (this.selFilteredDate == undefined) {
            this.getEmployeeList();
          } else {
            this.getEmployeeList(this.selFilteredDate);
          }
          this.enablePickupDrop();
          this.filterForm.controls['empCount'].patchValue('');
          this.filterForm.controls['shiftTime'].patchValue('');
        } else {
          this.swal.swalFunction('error', res.status, res.message, 5000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  closeAddEmpForm() {
    this.showAddForm = false;
    this.addFormSubmitted = false;
    this.addEmpShift = '';
  }

  //Create group
  public createGroupData: any = [];
  public disableCreate: boolean = true;

  //For Move
  public finalizedData: any = [];
  public showEmpCount: boolean = false;
  public disableMove: boolean = true;
  public selectedEmpCount: number = 0;
  clickToMove() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to finalize the group!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#4caf50 ',
      confirmButtonText: 'Confirm',
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        let rosterIds = Object.keys(this.mergeGroupsData);
        let obj = {
          type: 'Move',
          rosterID: rosterIds,
          branchInfo: this.branchInfo
          // "tripDate":1683916200000,
          // tripDate:new Date().getTime(),
        }

        if (this.selFilteredDate != undefined) {
          obj['tripDate'] = this.selFilteredDate
        } else {
          obj['tripDate'] = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
        }
        this.api.transportManagerEditGrouping(obj).then((res: any) => {
          if (res && res.status == 'success') {
            this.swal.swalFunction('success', res.status, res.message, 5000);
            this.mergeGroupsData = {};
            this.mergeDataAreas = {};
            this.groupData = [];
            this.addEmpData = [];
            this.availableEmpInGroups = [];
            this.closeMerge();
            this.closeAddEmpForm();
            this.closeCreateEmpForm();
            if (this.selFilteredDate == undefined) {
              this.getEmployeeList();
            } else {
              this.getEmployeeList(this.selFilteredDate);
            }
          } else {
            this.swal.swalFunction('error', res.status, res.message, 5000);
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    });
  }

 //For Create
  public showCreateForm: boolean = false;
  public createEmpForm: FormGroup;
  public createFormSubmitted: boolean = false;
  public createEmpData: any = [];
  public empsLoc: any = [];
  openCreateEmployee() {
    
    this.empsLoc = [];
    if(this.rescheduleclick){
      this.groupCreateTitle='Edit Reschedule';
      let arr = [];
    for (let i = 0; i < this.addrescheduleEmpData.length; i++) {
      for (let j = 0; j < this.groupData.length; j++) {
        let data = this.groupData[j]['empInfo'].filter(e => e.empRefID == this.addrescheduleEmpData[i].empRefID);
        if (data.length > 0) {
          arr.push(data[0].area);
        }
      }
    }
    this.empsLoc = this.removeDuplicateString(arr);
    }else{
      this.groupCreateTitle='Create new group'
      let arr = [];
    for (let i = 0; i < this.addEmpData.length; i++) {
      for (let j = 0; j < this.groupData.length; j++) {
        let data = this.groupData[j]['empInfo'].filter(e => e.empRefID == this.addEmpData[i].empRefID);
        if (data.length > 0) {
          arr.push(data[0].area);
        }
      }
    }
    this.empsLoc = this.removeDuplicateString(arr);
    }
    this.createEmpFormLoad();
    document.getElementById('openCreateModalBtn')?.click();
    // this.addEmpForm.controls['area'].patchValue(this.addEmpArea);
    this.showCreateForm = true;
  }
  removeDuplicateString(arr) {
    return arr.filter((item,
      index) => arr.indexOf(item) === index);
  }
  createEmpFormLoad() {
    this.createEmpForm = new FormGroup({
      tripDate: new FormControl(this.com.timestampToDate(this.selTripDate, 'YMD', '-'), [Validators.required]),
      shiftTime: new FormControl('', [Validators.required]),
      area: new FormControl(this.empsLoc[0], [Validators.required]),
    })
  }
  public createCheckError = (controlName: string, errorName: string) => {
    return this.createEmpForm.controls[controlName].hasError(errorName);
  }
  submitCreateEmployee() {
    this.createFormSubmitted = true;
    if (this.createEmpForm.valid) {
      let obj = {
        type: 'Create',
        tripDate: new Date(this.createEmpForm.value.tripDate).getTime(),
        shiftTimeStr: this.createEmpForm.value.shiftTime,
        // "tripDate":1683916200000,
        // shiftTimeStr:'17:00',
        area: this.createEmpForm.value.area,
        empInfo: this.addEmpData,
        tripType: this.addEmpData[0].tripType,
        routeID: this.addEmpData[0].routeID,
        branchInfo: this.branchInfo
      }
      this.api.transportManagerEditGrouping(obj).then((res: any) => {
        if (res && res.status == 'success') {
          this.swal.swalFunction('success', res.status, res.message, 5000);
          this.mergeGroupsData = {};
          this.mergeDataAreas = {};
          document.getElementById('closeCreateBtn')?.click();
          this.groupData = [];
          this.addEmpData = [];
          this.availableEmpInGroups = [];
          this.closeMerge();
          this.closeAddEmpForm();
          this.closeCreateEmpForm();
          if (this.selFilteredDate == undefined) {
            this.getEmployeeList();
          } else {
            this.getEmployeeList(this.selFilteredDate);
          }
          this.enablePickupDrop();
          this.filterForm.controls['empCount'].patchValue('');
          this.filterForm.controls['shiftTime'].patchValue('');
        } else {
          this.swal.swalFunction('error', res.status, res.message, 5000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  closeCreateEmpForm() {
    this.showCreateForm = false;
    this.createFormSubmitted = false;
  }

  //For Remove
  public disableRemove: boolean = true;
  public showRemoveForm: boolean = false;
  public removeFormSubmitted: boolean = false;
  public removeEmpForm: FormGroup;

  openRemoveEmployee() {
    if (this.selFinalEmp.length > 0 && Object.keys(this.selFinalGroups).length <= 0) {
      this.empsLoc = [];
      let arr = [];
      let tripDate = ''
      for (let i = 0; i < this.selFinalEmp.length; i++) {
        for (let j = 0; j < this.finalizedData.length; j++) {
          let data = this.finalizedData[j]['empInfo'].filter(e => e.empRefID == this.selFinalEmp[i].empRefID);
          if (this.finalizedData[j]['empInfo'].filter(e => e.empRefID == this.selFinalEmp[i].empRefID)) {
            tripDate = this.finalizedData[j].tripDate;
          }
          if (data.length > 0) {
            arr.push(data[0].area);
          }
        }
      }

      this.empsLoc = this.removeDuplicateString(arr);
      this.removeEmpFormLoad(tripDate);
      document.getElementById('openRemoveModalBtn')?.click();
      this.showRemoveForm = true;
    } else if (Object.keys(this.selFinalGroups).length > 0 && this.selFinalEmp.length == this.selFinalGroupEmps.length) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to re-group the selected group!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Confirm'
      }).then((result) => {
        if (result.isConfirmed) {
          let rosterIds = Object.keys(this.selFinalGroups);
          let obj = {
            type: 'Back to grouping',
            rosterID: rosterIds,
            branchInfo: this.branchInfo
            // "tripDate":1683916200000,
            // tripDate:new Date().getTime(),
          }
          if (this.selFilteredDate != undefined) {
            obj['tripDate'] = this.selFilteredDate
          } else {
            obj['tripDate'] = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
          }
          this.api.transportManagerEditGrouping(obj).then((res: any) => {
            if (res && res.status == 'success') {
              this.swal.swalFunction('success', res.status, res.message, 5000);
              this.selFinalGroups = {};
              this.selFinalEmp = [];
              this.selFinalGroupEmps = [];
              if (this.selFilteredDate == undefined) {
                this.getEmployeeList();
              } else {
                this.getEmployeeList(this.selFilteredDate);
              }
              this.isFirstTime = true;
            } else {
              this.swal.swalFunction('error', res.status, res.message, 5000);
            }
          }).catch((err) => {
            console.log(err);
          });
        }
      });
    }
  }
  removeEmpFormLoad(date: any) {
    this.removeEmpForm = new FormGroup({
      tripDate: new FormControl(this.com.timestampToDate(date, 'YMD', '-'), [Validators.required]),
      shiftTime: new FormControl('', [Validators.required]),
      area: new FormControl(this.empsLoc[0], [Validators.required]),
    })
  }
  public removeCheckError = (controlName: string, errorName: string) => {
    return this.removeEmpForm.controls[controlName].hasError(errorName);
  }
  submitRemove() {
    this.removeFormSubmitted = true;
    if (this.removeEmpForm.valid) {
      let obj = {
        type: 'Remove',
        tripDate: new Date(this.removeEmpForm.value.tripDate).getTime(),
        shiftTimeStr: this.removeEmpForm.value.shiftTime,
        // "tripDate":1683916200000,
        // shiftTimeStr:'17:00',
        area: this.removeEmpForm.value.area,
        empInfo: this.selFinalEmp,
        tripType: this.selFinalEmp[0].tripType,
        routeID: this.selFinalEmp[0].routeID,
        branchInfo: this.branchInfo
      }
      this.api.transportManagerEditGrouping(obj).then((res: any) => {
        if (res && res.status == 'success') {
          this.swal.swalFunction('success', res.status, res.message, 5000);
          this.selFinalGroups = {};
          this.selFinalEmp = [];
          this.selFinalGroupEmps = [];
          this.disableRemove = true;
          document.getElementById('closeRemoveBtn')?.click();
          this.closeRemoveEmpForm();
          if (this.selFilteredDate == undefined) {
            this.getEmployeeList();
          } else {
            this.getEmployeeList(this.selFilteredDate);
          }
          this.isFirstTime = true;
          this.enablePickupDrop();
          this.filterForm.controls['empCount'].patchValue('');
          this.filterForm.controls['shiftTime'].patchValue('');
        } else {
          this.swal.swalFunction('error', res.status, res.message, 5000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  closeRemoveEmpForm() {
    this.showRemoveForm = false;
    this.removeFormSubmitted = false;
  }


  //For right side area check box
  public finalAllCheck: boolean = false;
  public finalAllIndeterminate: boolean = false;
  public selFinalGroups: any = {};
  public selFinalEmp: any = [];
  public selFinalGroupEmps: any = [];
  selectAllFinalGroup(event) {
    this.finalAllCheck = event;
    this.finalAllIndeterminate = false;
    for (let i = 0; i < this.finalizedData.length; i++) {
      this.finalizedData[i].checked = event;
      this.finalizedData[i].indeterminate = false;
      if (this.finalizedData[i].empInfo && this.finalizedData[i].empInfo.length > 0) {
        let data = this.finalizedData[i];
        
        this.selectFinalGroup(event, data.rosterID, i);
      }
    }

  }
  selectFinalGroup(event, rosterId, index) {
    //merge
    if (event) {
      let data = {};
      data[rosterId] = this.finalizedData[index].empInfo;

      this.selFinalGroups = {
        ...this.selFinalGroups,
        ...data
      }
    } else {
      delete this.selFinalGroups[rosterId];
    }

    this.finalizedData[index]['checked'] = event;
    this.finalizedData[index]['indeterminate'] = false;
    if (this.finalizedData[index]['empInfo'] && this.finalizedData[index]['empInfo'].length > 0) {
      let employee = this.finalizedData[index]['empInfo'];
      for (let i = 0; i < employee.length; i++) {
        employee[i].checked = event;
        employee[i].oldRosterID = rosterId;
      }
      //For Add and Create
      if (event) {
        let arr1 = [...this.selFinalEmp, ...employee];
        this.selFinalEmp = this.removeDuplicates(arr1, 'empRefID');
        let arr2 = [...this.selFinalGroupEmps, ...employee];
        this.selFinalGroupEmps = this.removeDuplicates(arr2, 'empRefID');
      } else {
        for (let k = 0; k < employee.length; k++) {
          let index = this.selFinalEmp.findIndex(e => e.empRefID == employee[k].empRefID);
          if (index != -1) {
            this.selFinalEmp.splice(index, 1);
          }
          let index2 = this.selFinalGroupEmps.findIndex(e => e.empRefID == employee[k].empRefID);
          if (index2 != -1) {
            this.selFinalGroupEmps.splice(index2, 1);
          }
        }
      }
    }
    this.checkAllFinalGroupChecked();
  }
  selectFinalEmployee(event, rosterId, empId, i) {
    this.groupTableHeight = '60.5vh';
    let index = this.finalizedData[i]['empInfo'].findIndex(e => e.empRefID == empId);
    if (index != -1) {
      this.finalizedData[i]['empInfo'][index].checked = event;
      this.finalizedData[i]['empInfo'][index].oldRosterID = rosterId;
    }
    if (event) {
      this.selFinalEmp.push(this.finalizedData[i]['empInfo'][index]);
    } else {
      let empIndex = this.selFinalEmp.findIndex(e => e.empRefID == empId);
      if (empIndex != -1) {
        this.selFinalEmp.splice(empIndex, 1);
      }
    }
    this.checkAllFinalEmployeeChecked(event, rosterId, i);
    this.checkAllFinalGroupChecked();
  }
  checkAllFinalEmployeeChecked(event, rosterId, index) {
    let employee = this.finalizedData[index]['empInfo'];
    let isValid = true;
    for (let i = 0; i < employee.length; i++) {
      if (employee[i].checked == false || employee[i].checked == undefined) {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    let selStatus = false;
    if (isValid) {
      this.finalizedData[index].checked = isValid;
      this.finalizedData[index].indeterminate = !isValid;

      let arr2 = [...this.selFinalGroupEmps, ...employee];
      this.selFinalGroupEmps = this.removeDuplicates(arr2, 'empRefID');

      //Merge
      let data = {};
      data[rosterId] = this.finalizedData[index].empInfo;

      this.selFinalGroups = {
        ...this.selFinalGroups,
        ...data
      }
    } else {
      for (let k = 0; k < employee.length; k++) {
        let index2 = this.selFinalGroupEmps.findIndex(e => e.empRefID == employee[k].empRefID);
        if (index2 != -1) {
          this.selFinalGroupEmps.splice(index2, 1);
        }
      }
      //Merge
      delete this.selFinalGroups[rosterId];

      let checkArr = [];
      let indeterArr = [];
      for (let i = 0; i < employee.length; i++) {
        if (employee[i].checked) {
          checkArr.push('checked');
        } else if (employee[i].indeterminate) {
          indeterArr.push('indeterminate');
        }
      }
      let group = this.finalizedData[index];
      if (checkArr.length <= 0 && indeterArr.length <= 0) {
        group.indeterminate = isValid;
        group.checked = isValid;
      } else if (checkArr.length == employee.length) {
        group.checked = !isValid;
        group.indeterminate = isValid;
      } else if (indeterArr.length == employee.length) {
        group.indeterminate = !isValid;
        group.checked = isValid;
      } else {
        group.indeterminate = !isValid;
        group.checked = isValid;
      }
      if (indeterArr.length > 1) {
        selStatus = true;
      } else {
        selStatus = false;
      }
    }
    this.findClickedTripDateInRouting('tripDate');
    if ((this.selFinalEmp.length > 0 && Object.keys(this.selFinalGroups).length <= 0) ||
      (Object.keys(this.selFinalGroups).length > 0 && !selStatus && this.selFinalEmp.length == this.selFinalGroupEmps.length)) {
      this.disableRemove = false;
    } else {
      this.disableRemove = true;
    }
  }
  findClickedTripDateInRouting(key) {
    let arr = [];
    for (let i = 0; i < this.finalizedData.length; i++) {
      if (this.finalizedData[i].checked || this.finalizedData[i].indeterminate) {
        let index = arr.findIndex(e => e == this.finalizedData[i][key]);
        if (index == -1) arr.push(this.finalizedData[i][key]);
      }
    }
    if (key == 'tripDate') {
      if (arr.length == 1) {
        this.selRoutingTripDate = arr[0];
      } else {
        this.selRoutingTripDate = '';
      }
    }
  }

  checkAllFinalGroupChecked() {
    let isValid = true;
    for (let i = 0; i < this.finalizedData.length; i++) {
      if (this.finalizedData[i].checked == false || this.finalizedData[i].checked == undefined) {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    let selStatus = false;
    if (isValid) {
      this.finalAllCheck = isValid;
      this.finalAllIndeterminate = !isValid;
    } else {
      let checkArr = [];
      let indeterArr = [];
      for (let i = 0; i < this.finalizedData.length; i++) {
        if (this.finalizedData[i].checked) {
          checkArr.push('checked');
        } else if (this.finalizedData[i].indeterminate) {
          indeterArr.push('indeterminate');
        }
      }
      if (checkArr.length <= 0 && indeterArr.length <= 0) {
        this.finalAllCheck = isValid;
        this.finalAllIndeterminate = isValid;
      } else if (checkArr.length == this.finalizedData.length) {
        this.finalAllCheck = !isValid;
        this.finalAllIndeterminate = isValid;
      } else if (indeterArr.length == this.finalizedData.length) {
        this.finalAllCheck = isValid;
        this.finalAllIndeterminate = !isValid;
      } else {
        this.finalAllCheck = isValid;
        this.finalAllIndeterminate = !isValid;
      }
      if (indeterArr.length > 1) {
        selStatus = true;
      } else {
        selStatus = false;
      }
    }
    this.findClickedTripDateInRouting('tripDate');
    if ((this.selFinalEmp.length > 0 && Object.keys(this.selFinalGroups).length <= 0) ||
      (Object.keys(this.selFinalGroups).length > 0 && !selStatus && this.selFinalEmp.length == this.selFinalGroupEmps.length)) {
      this.disableRemove = false;
    } else {
      this.disableRemove = true;
    }
  }


  removeDuplicates(arr, name) {
    let x = [];
    const unique = arr.filter(element => {
      const isDuplicate = x.includes(element[name]);

      if (!isDuplicate) {
        x.push(element[name]);

        return true;
      } else {
        return false;
      }
    });
    return unique;
  }
  formatDate(date) {
    var today: any = date;
    var dd: any = today.getDate();
    var mm: any = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }

    today = yyyy + '-' + mm + '-' + dd;
    return today;
  }
  public hidePickupData: boolean = false;
  public hideDropData: boolean = false;
  removePickupDatas() {
    this.hidePickupData = this.hidePickupData == true ? false : true;
    let badge = document.getElementById('onlyPickup');
    if (badge.classList.contains('badge-secondary')) {
      badge.classList.replace('badge-secondary', 'badge-light');
    } else {
      badge.classList.replace('badge-light', 'badge-secondary');
    }
    // this.filterForm.controls['empCount'].patchValue('');
    // this.filterForm.controls['shiftTime'].patchValue('');
    if (this.hidePickupData && !this.hideDropData) {
      this.groupData = this.storedData.filter(e => e.transitMode == 'drop' || e.transitMode == 'Drop');
      this.selectedTrip = ['Drop'];
    } else if (!this.hidePickupData && this.hideDropData) {
      this.selectedTrip = ['Pickup'];
      this.groupData = this.storedData.filter(e => e.transitMode == 'pickup' || e.transitMode == 'Pickup');
    } else if (!this.hidePickupData && !this.hideDropData) {
      this.selectedTrip = ['Pickup', 'Drop'];
      this.groupData = this.storedData;
    } else {
      this.selectedTrip = [];
      this.groupData = [];
    }
    if (this.selFilteredDate == undefined) {
      this.getEmployeeList();
    } else {
      this.getEmployeeList(this.selFilteredDate);
    }
    if (this.hidePickupData && this.hideDropData) {
      this.noData = 'Select any transit mode';
    } else {
      this.noData = 'No group found';
    }
    // this.findFemaleEmployee();
    // this.findAvailableShiftandEmpCount();
  }
  removeDropDatas() {
    this.hideDropData = this.hideDropData == true ? false : true;
    let badge = document.getElementById('onlyDrop');
    if (badge.classList.contains('badge-secondary')) {
      badge.classList.replace('badge-secondary', 'badge-light');
    } else {
      badge.classList.replace('badge-light', 'badge-secondary');
    }
    // this.filterForm.controls['empCount'].patchValue('');
    // this.filterForm.controls['shiftTime'].patchValue('');
    if (this.hidePickupData && !this.hideDropData) {
      this.groupData = this.storedData.filter(e => e.transitMode == 'drop');
      this.selectedTrip = ['Drop'];
    } else if (!this.hidePickupData && this.hideDropData) {
      this.selectedTrip = ['Pickup'];
      this.groupData = this.storedData.filter(e => e.transitMode == 'pickup');
    } else if (!this.hidePickupData && !this.hideDropData) {
      this.selectedTrip = ['Pickup', 'Drop'];
      this.groupData = this.storedData;
    } else {
      this.selectedTrip = [];
      this.groupData = [];
    }
    if (this.selFilteredDate == undefined) {
      this.getEmployeeList();
    } else {
      this.getEmployeeList(this.selFilteredDate);
    }
    // this.findFemaleEmployee();
    // this.findAvailableShiftandEmpCount();
    if (this.hidePickupData && this.hideDropData) {
      this.noData = 'Select any transit mode';
    } else {
      this.noData = 'No group found';
    }
  }
  enablePickupDrop() {
    this.selectedTrip = ['Pickup', 'Drop'];
    let badge1 = document.getElementById('onlyPickup');
    if (badge1.classList.contains('badge-light')) {
      badge1.classList.replace('badge-light', 'badge-secondary');
    }
    this.hidePickupData = false;
    let badge2 = document.getElementById('onlyDrop');
    if (badge2.classList.contains('badge-light')) {
      badge2.classList.replace('badge-light', 'badge-secondary');
    }
    this.hideDropData = false;
  }
  disablePickupDrop() {
    this.selectedTrip = [];
    let badge1 = document.getElementById('onlyPickup');
    if (badge1.classList.contains('badge-secondary')) {
      badge1.classList.replace('badge-secondary', 'badge-light');
    }
    this.hidePickupData = true;
    let badge2 = document.getElementById('onlyDrop');
    if (badge2.classList.contains('badge-secondary')) {
      badge2.classList.replace('badge-secondary', 'badge-light');
    }
    this.hideDropData = true;
  }

  //Cab resource planning
  public resourcePlanData: any = {};
  public cabResEmpCounts: any = [];
  public vehicleModals = [
    { name: "Hatchback", capacity: 3, count: 0 },
    { name: "Sedan", capacity: 4, count: 0 },
    { name: "SUV", capacity: 7, count: 0 },
    { name: "TT (12)", capacity: 12, count: 0 },
    { name: "TT (20)", capacity: 20, count: 0 },
    { name: "Van", capacity: 25, count: 0 },
    { name: "Bus", capacity: 60, count: 0 },
  ]
  public showResourceData: boolean = false;

  getActiveTabData(day) {
    this.vehicleModals = [
      { name: "Hatchback", capacity: 3, count: 0 },
      { name: "Sedan", capacity: 4, count: 0 },
      { name: "SUV", capacity: 7, count: 0 },
      { name: "TT (12)", capacity: 12, count: 0 },
      { name: "TT (20)", capacity: 20, count: 0 },
      { name: "Van", capacity: 25, count: 0 },
      { name: "Bus", capacity: 60, count: 0 },
    ]
    let currentDate = new Date();
    let date;
    if (day == 'yesterday') {
      let yesterday = new Date(currentDate);
      yesterday.setDate(yesterday.getDate() - 1);
      let previousDate = yesterday.getTime();
      date = new Date(previousDate).setHours(0, 0, 0, 0);
    } else if (day == 'today') {
      date = new Date().setHours(0, 0, 0, 0);
    } else if (day == 'tomorrow') {
      let nextDay = new Date(currentDate);
      nextDay.setDate(nextDay.getDate() + 1);
      let nextDate = nextDay.getTime();
      date = new Date(nextDate).setHours(0, 0, 0, 0);
    }
    this.cabResEmpCounts = this.resourcePlanData[date];

    if (this.cabResEmpCounts == undefined || this.cabResEmpCounts.length <= 0) {
      this.cabResEmpCounts = [];
      return;
    }

    for (let i = 0; i < this.cabResEmpCounts.length; i++) {
      let index = -1;
      if (this.cabResEmpCounts[i] <= 3) {
        index = this.vehicleModals.findIndex(e => e.name == 'Hatchback');
      } else if (this.cabResEmpCounts[i] == 4) {
        index = this.vehicleModals.findIndex(e => e.name == 'Sedan');
      } else if (this.cabResEmpCounts[i] > 4 && this.cabResEmpCounts[i] <= 7) {
        index = this.vehicleModals.findIndex(e => e.name == 'SUV');
      } else if (this.cabResEmpCounts[i] > 7 && this.cabResEmpCounts[i] <= 12) {
        index = this.vehicleModals.findIndex(e => e.name == 'TT (12)');
      } else if (this.cabResEmpCounts[i] > 12 && this.cabResEmpCounts[i] <= 20) {
        index = this.vehicleModals.findIndex(e => e.name == 'TT (20)');
      } else if (this.cabResEmpCounts[i] > 20 && this.cabResEmpCounts[i] <= 25) {
        index = this.vehicleModals.findIndex(e => e.name == 'Van');
      } else if (this.cabResEmpCounts[i] > 25) {
        index = this.vehicleModals.findIndex(e => e.name == 'Bus');
      }
      this.vehicleModals[index].count += 1;
    }
  }
  viewCabResource() {
    this.showResourceData = false;
    this.resourcePlanData = {}
    for (let i = 0; i < this.groupData.length; i++) {
      if (this.resourcePlanData[this.groupData[i].tripDate]) {
        this.resourcePlanData[this.groupData[i].tripDate].push(this.groupData[i].empInfo.length);
      } else {
        this.resourcePlanData[this.groupData[i].tripDate] = [];
        this.resourcePlanData[this.groupData[i].tripDate].push(this.groupData[i].empInfo.length);
      }
    }
    this.getActiveTabData('today');
    document.getElementById('openResourcePlanModalBtn')?.click();
    this.showResourceData = true;
  }
  closeResourcePlan() {
    this.showResourceData = false;
    this.resourcePlanData = {};
    this.cabResEmpCounts = [];
  }

  //Map
  public empLocs: any = [];
  public wayPoints: any = [];
  public routeLine: any;
  public plotPath: any;
  public plottedLines: any = [];
  public lineCoardinate: any = [];
  async viewEmpInMap(group) {
    document.getElementById('openMapModalBtn')?.click();
    let employees = JSON.parse(JSON.stringify(group.empInfo));
    if (group.branchInfo) {
      if (group.transitMode == 'Pickup') {
        employees.push(group.branchInfo);
      }
      else {
        employees.unshift(group.branchInfo);
      }

    }

    for (let i = 0; i < employees.length; i++) {
      if (employees[i].location && employees[i].location['lat'] && employees[i].location['lng']) {
        if (this.selectedMap == 'google') {
          let obj = {};
          if (employees[i].empRefID) {
            obj = {
              name: employees[i].name,
              ID: employees[i].empRefID,
              mobile: employees[i].mobile,
              type: 'Employee'
            }
            if (group.transitMode == 'Pickup') {
              obj['pp'] = i + 1;
            }
            if (group.transitMode == 'Drop') {
              obj['dd'] = i;
            }
          } else {
            obj = {
              name: employees[i].name,
              type: 'Branch'
            }
          }
          let arr = [
            employees[i].location['lat'],
            employees[i].location['lng'],
            { pp: true }
          ]
          this.empLocs.push(arr);
          this.placeMarker(employees[i].location['lat'], employees[i].location['lng'], obj);
        } else {
          this.locationMarker(employees[i].location['lat'], employees[i].location['lng']);
        }
      }
    }
    for (let i = 0; i < this.empLocs.length; i++) {
      if (i > 0) {
        let arr = [this.empLocs[i - 1], this.empLocs[i]];
        // console.log("arrr>",arr)
        let points: any = await this.routeservice.findWayPoints(arr);
        this.wayPoints = [...this.wayPoints, ...points];
      }
    }
    if (this.wayPoints.length > 0) {
      for (let l = 0; l < this.wayPoints.length; l++) {
        let obj = {
          lat: +this.wayPoints[l][0],
          lng: +this.wayPoints[l][1]
        }
        this.lineCoardinate.push(obj);
      }
      for (let m = 0; m < this.lineCoardinate.length; m++) {
        if (m > 0) {
          let arr = [this.lineCoardinate[m - 1], this.lineCoardinate[m]];
          let line = await this.drawLine(arr, m);
          this.plotPath = line;
          this.plotPath.setMap(this.googleMapObj);
          this.plottedLines.push(line);
        }
      }


    }
  }
  drawLine(arr, index) {
    return new Promise((res, rej) => {
      const lineSymbol = {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        strokeColor: 'black',
        strokeWeight: 2,
        scale: 3
      };
      let line;
      if (index % 5 == 0 && index != 0) {
        line = new google.maps.Polyline({
          path: arr,
          geodesic: true,
          strokeColor: "#0F15C8",
          strokeOpacity: 1.0,
          strokeWeight: 4,
          visible: true,
          icons: [
            {
              icon: lineSymbol,
              offset: "50%",
            },
          ],
        })
      } else {
        line = new google.maps.Polyline({
          path: arr,
          geodesic: true,
          strokeColor: "#0F15C8",
          strokeOpacity: 1.0,
          strokeWeight: 4,
          visible: true,
        })
      }
      res(line);
    })
  }

  loadMap() {
    if (this.selectedMap == 'google') {
      setTimeout(() => {
        const mapOptions = {
          scrollwheel: true,
          zoom: 5,
          maxZoom: 17,
          center: new google.maps.LatLng(12.9716, 77.5946),
          fullscreenControl: false,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP,
          },
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            // position: google.maps.ControlPosition.TOP_CENTER,
          },
          streetViewControl: false,
        };
        let user = this.storage.get('userInfo')

        if (user.defaultLoc != undefined) {
          mapOptions.center = new google.maps.LatLng(user.defaultLoc.lat, user.defaultLoc.lng)
          mapOptions.zoom = 9;
        }

        this.googleMapObj = new google.maps.Map(document.getElementById('locationMap'), mapOptions);
      }, 1000)
    } else {
      this.mapService.map("locationMap").then((map) => {
        this.locationMap = map;
      }).catch((error) => {
        console.log(error)
      });
    }
  }
  placeMarker(lat, lng, emp) {
    let latLng = new google.maps.LatLng(+lat, +lng);
    let image = {
      origin: new google.maps.Point(0, 0),
      scaledSize: new google.maps.Size(50, 50),
    };
    // let marker = new google.maps.Marker({
    //   position: latLng, 
    //   map: this.googleMapObj,
    // });
    let marker;
    if (emp.type == 'Branch') {
      image['url'] = "assets/images/map/branch.png";
      marker = new google.maps.Marker({
        position: latLng,
        map: this.googleMapObj,
        icon: image
      });

    } else {
      marker = new google.maps.Marker({
        position: latLng,
        map: this.googleMapObj,
      });
    }
    let infoWindowContent;
    let infowindow;
    marker.addListener('click', (e) => {
      if (infowindow) infowindow.close();
      if (emp.type == 'Employee') {
        if (emp.dd != undefined) {
          infoWindowContent = '<div class="window-content-container"><div>' + 'Drop point :' + '<span>' + ' ' + emp.dd + '</span></div><div style="margin-top:2px">' + 'Name :' + '<span>' + ' ' + emp.name + '</span></div><div style="margin-top:2px">' + 'Employee ID :' + ' ' + '<span>' + emp.ID.toUpperCase() + ' ' + '</span>' + '</div><div style="margin-top:2px">' + 'Mobile :' + ' ' + '<span>' + emp.mobile + ' ' + '</span>' + '</div>' + '</div>';
        }
        if (emp.pp != undefined) {
          infoWindowContent = '<div class="window-content-container"><div>' + 'Pickup point :' + '<span>' + ' ' + emp.pp + '</span></div><div style="margin-top:2px">' + 'Name :' + '<span>' + ' ' + emp.name + '</span></div><div style="margin-top:2px">' + 'Employee ID :' + ' ' + '<span>' + emp.ID.toUpperCase() + ' ' + '</span>' + '</div><div style="margin-top:2px">' + 'Mobile :' + ' ' + '<span>' + emp.mobile + ' ' + '</span>' + '</div>' + '</div>';
        }

      } else if (emp.type == 'Branch') {
        infoWindowContent = '<div class="window-content-container"><div>' + 'Branch :' + '<span>' + ' ' + emp.name + '</span>' + '</div></div>';
      }
      infowindow = new google.maps.InfoWindow({
        content: infoWindowContent
      });
    })
    google.maps.event.addListener(marker, 'click', function () {
      infowindow.open(this.googleMapObj, this);
    });
    this.markersArray.push(marker)
    if (emp.type == 'Branch') {
      this.googleMapObj.panTo(latLng);//for focusing marked location
    }
    if (emp.type == 'Branch') this.googleMapObj.setZoom(15);
  }

  clearOverlays() {
    for (var i = 0; i < this.markersArray.length; i++) {
      this.markersArray[i].setMap(null);
    }
    this.markersArray = [];
  }
  locationMarker(lat, lng) {
    if (this.locationMap != undefined) {
      this.markerId = 'pickLocation' + Math.round(Math.random() * 10000);
      lat = +lat.toFixed(5); lng = +lng.toFixed(5);
      this.locationMap.marker(
        {
          id: this.markerId,
          content: '<div class="mumb_marker_pin" style="background: #686ab9;"></div>',
          lat: lat,
          lng: lng,
        }
      );
      this.locationMap.focus({
        lat: lat,
        lng: lng,
        zoom: 14
      });
    }
  }
  closeMapModal() {
    if (this.selectedMap == 'google') {
      if (this.markersArray.length > 0) {
        this.clearOverlays();
      }
      if (this.plotPath) {
        this.plotPath.setMap(null);
      }
      this.empLocs = [];
      this.wayPoints = [];
    } else {
      this.locationMap.removeMarkerAll();
    }
    this.lineCoardinate = [];
    if (this.plottedLines.length > 0) {
      for (let i = 0; i < this.plottedLines.length; i++) {
        this.plottedLines[i].setMap(null);
      }
    }
    this.plottedLines = [];
  }


  //For create group
  public groupCreateForm: FormGroup;
  // public empFilterForm:FormGroup;
  public showGroupCreateForm: boolean = false;
  public groupCreateFormSubmitted: boolean = false;
  public groupCreateTitle: any = 'Create new group';
  public adhocEmps: any = [];
  public showEmpTable: boolean = false;
  public searchedValue: string = '';
  public availableSearchEmps: any = [];
  public selectedEmployee: any = [];
  public finalizedEmps: any = [];
  public finalizedEmpArea: any = [];

  branchList: any;

  public selClickedTripType: string = '';
  openCreateGroup() {
    this.getListShift();
    this.getAddEmpList();
    this.groupCreateFormLoad();
    this.showGroupCreateForm = true;
    document.getElementById('openCreateGroupModalBtn')?.click();
  }
  groupCreateFormLoad() {
    this.groupCreateForm = new FormGroup({
      tripDate: new FormControl(this.com.timestampToDate(new Date().getTime(), 'YMD', '-'), [Validators.required]),
      branch: new FormControl(this.choosenBranch && this.choosenBranch.length > 0 ? this.choosenBranch[0] : '', [Validators.required]),
      // branch: new FormControl(this.branchInformation[this.choosenBranch[0]], [Validators.required]),
      transitMode: new FormControl('', [Validators.required]),
      shiftTime: new FormControl('', [Validators.required]),
      area: new FormControl('', [Validators.required]),
      adhocEmployee: new FormControl(false)
      
    })
    this.disableTripType();
  }
  public groupCreateCheckError = (controlName: string, errorName: string) => {
    return this.groupCreateForm.controls[controlName].hasError(errorName);
  }
  closeCreateGroupForm() {
    this.groupCreateFormSubmitted = false;
    this.finalizedEmps = [];
    this.finalizedEmpArea = [];
    this.selectedEmployee = [];
    this.groupCreateForm.controls['tripDate'].patchValue('');
    this.groupCreateForm.controls['branch'].patchValue('');
    this.groupCreateForm.controls['transitMode'].patchValue('');
    this.groupCreateForm.controls['shiftTime'].patchValue('');
    document.getElementById('closeCreateGroupBtn')?.click();
  }

  // groupCreateFormSubmit() {
  //   this.groupCreateFormSubmitted = true;
  //   if (this.groupCreateForm.valid) {
  //     if (this.finalizedEmps.length > 0) {
  //       let obj = {
  //         tripDate: new Date(this.groupCreateForm.value.tripDate).getTime(),
  //         branchInfo: this.branchInfo,
  //         transitMode: this.groupCreateForm.value.transitMode,
  //         shiftTimeStr: this.groupCreateForm.value.shiftTime,
  //         empInfo: this.finalizedEmps,
  //         area: this.groupCreateForm.value.area,
  //         groupType:this.selectedItem,
  //         // groupType: "adhoc",
  //       }
  //       this.createRoute(obj);
  //     } else {
  //       this.swal.swalFunction('warning', 'Kindly assign employee!', '', 5000);
  //     }
  //   }
  // }
  
  groupCreateFormSubmit() {
  this.groupCreateFormSubmitted = true;

  if (this.groupCreateForm.valid) {
    if (this.finalizedEmps.length > 0) {

      // derive groupType
      const groupType = this.groupCreateForm.value.adhocEmployee ? 'adhoc' : 'roster';
      
      
      let obj = {
        tripDate: new Date(this.groupCreateForm.value.tripDate).getTime(),
        branchInfo: this.branchInfo,
        transitMode: this.groupCreateForm.value.transitMode,
        shiftTimeStr: this.groupCreateForm.value.shiftTime,
        empInfo: this.finalizedEmps,
        area: this.groupCreateForm.value.area,
        groupType: groupType
      };

       console.log('📦 Payload going to API:', obj);
      this.createRoute(obj);

    } else {
      this.swal.swalFunction('warning', 'Kindly assign employee!', '', 5000);
    }
  }
}


  createRoute(obj: any) {
    this.api.transportManagerRosterRouteCreate(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, 'success', res.message, 5000);
        this.closeCreateGroupForm();
        if (this.selFilteredDate == undefined) {
          this.getEmployeeList();
        } else {
          this.getEmployeeList(this.selFilteredDate);
        }
      } else {
        this.swal.swalFunction(res.status, res.status, res.message, 5000);
      }
    }).catch((err) => console.log(err));
  }

  
  openAddEmpScreen() {
    // this.empFilterForm = new FormGroup({
    //   tripDate: new FormControl(this.com.timestampToDate(new Date().getTime(),'YMD','-')),
    // })
    if(this.selected_Value=='pickup'|| this.selected_Value =='drop'){
      this.enable_emplist=false;
    }
    this.selClickedTripType = this.groupCreateForm.value.transitMode != '' ? (this.groupCreateForm.value.transitMode == 'pickup' ? 'Pickup' : 'Drop') : '';
    this.selectedEmployee = [];
    this.getAddEmpList();
    this.groupCreateTitle = 'Add employee';
    this.showEmpTable = true;
  }
  

  onchangeList(item:any){
    if(item=="adhoc"){
      this.availableSearchEmps=this.addemployeesresponse.adhoc;
      this.adhocEmps=this.addemployeesresponse.adhoc;
    }else if(item=="reschedule")
    {
      this.availableSearchEmps=this.addemployeesresponse.reschedule;
      this.adhocEmps=this.addemployeesresponse.reschedule;
    }else if(item=="employee"){
      this.availableSearchEmps=this.addemployeesresponse.emp;
      this.adhocEmps=this.addemployeesresponse.emp;
    }

  }

  
selectAddEmployee(value, employee) {
    console.log("select particular employee",employee)
    // let index1;
    

    // if(this.selectedItem=='employee')
    // {
    //   index1 = this.availableSearchEmps.findIndex(e => e.empRefID == employee.empRefID);
    // }else{
    //   index1 = this.availableSearchEmps.findIndex(e => e.empAdhocID == employee.empAdhocID);
    // }
    // if (index1 != -1) {
    //   this.availableSearchEmps[index1]['checked'] = value;
    // }
    
    this.selectedEmployee = this.availableSearchEmps.filter(e => e.checked);
    console.log("select particular2 employee",this.selectedEmployee)
    // if (this.selectedEmployee.length > 0) {
    //   this.selClickedTripType = this.selectedEmployee[0].transitMode;
    // } else {
    //   this.selClickedTripType = '';
    // }
    if (value) {
    // Set based on currently selected employee
    this.selClickedTripType = employee.transitMode;
  } else if (this.selectedEmployee.length > 0) {
    // Fall back to last checked employee if needed
    this.selClickedTripType = this.selectedEmployee[this.selectedEmployee.length - 1].transitMode;
  } else {
    this.selClickedTripType = '';
  }
  }
  
  getParticularEmpDetail(emp) {
    return new Promise((resolve, reject) => {
      const obj = {
        orgID: this.storage.get('userInfo').orgID,
        page: 1,
        limit: 1,
        search: emp.empRefID
      };
      this.api.transportManagerEmployeeListHl(obj).then((res: any) => {
        if (res.status == 'success' && res.data && res.data.length > 0) {
          let employee = res.data[0];
          employee['status'] = emp.status;
          employee['tripType'] = emp.transitMode ? emp.transitMode : emp.tripType;
          resolve(employee);
        } else {
          let employee = this.adhocResList.filter(e => e.empRefID == emp.empRefID);
          employee['status'] = emp.status;
          employee['tripType'] = emp.transitMode ? emp.transitMode : emp.tripType;
          resolve(employee);
        }
      }).catch((err) => {
        console.log(err);
      });
    })
  }
  getAllDetailsOfEmp(emps) {
    return new Promise(async (resolve, reject) => {

      let arr = [];
      for (let i = 0; i < emps.length; i++) {
        let data = await this.getParticularEmpDetail(emps[i]);

        arr.push(data);
      }
      resolve(arr);
    })
  }
  async addEmpToGroup() {
    let data = [...this.finalizedEmps, ...this.selectedEmployee];

    this.finalizedEmps = await this.getAllDetailsOfEmp(data);

    try{
      if (this.finalizedEmps.length > 0) {
        this.selClickedTripType = this.finalizedEmps[0].tripType;
        this.groupCreateForm.controls['transitMode'].patchValue(this.selClickedTripType.toLowerCase() == 'pickup' ? 'pickup' : 'drop');
      } else {
        this.selClickedTripType = '';
        this.groupCreateForm.controls['transitMode'].patchValue('');
      }

    }catch(ex){

    }
    
    this.disableTripType();
    // this.finalizedEmpArea = [];
    // let arr = [];
    // for (let i = 0; i < this.finalizedEmps.length; i++) {
    //   arr.push(this.finalizedEmps[i].area);
    // }
    // this.finalizedEmpArea = this.removeDuplicateString(arr);
    this.cancelEmpSelect();
  }
  disableTripType() {
    if (this.selClickedTripType != '') {
      setTimeout(() => {
        let transitModeDiv: any = document.getElementById('transitMode');
        transitModeDiv.disabled = false;
      }, 100)
    } else {
      setTimeout(() => {
        let transitModeDiv: any = document.getElementById('transitMode');
        transitModeDiv.disabled = false;
      }, 100)
    }
  }
  cancelEmpSelect() {
    this.selClickedTripType = '';
    this.groupCreateTitle = 'Create new group';
    this.showEmpTable = false;
    this.adhocEmps = [];
    this.availableSearchEmps = [];
    this.searchedValue = '';
    this.disableTripType();
  }
  findEmployee(searchValue) {
    this.searchedValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');
    let data = this.adhocEmps.filter(e => e.name.toLowerCase().includes(this.searchedValue.toLowerCase()) || e.empRefID.toLowerCase().includes(this.searchedValue.toLowerCase()));
    this.availableSearchEmps = data;
  }

  movies = [
    'Episode I - The Phantom Menace',
    'Episode II - Attack of the Clones',
    'Episode III - Revenge of the Sith',
    'Episode IV - A New Hope',
    'Episode V - The Empire Strikes Back',
    'Episode VI - Return of the Jedi',
    'Episode VII - The Force Awakens',
    'Episode VIII - The Last Jedi',
  ];

  onDrop(event: CdkDragDrop<any[]>) {
 
    const prevIndex = this.reOrderArr.findIndex((item) => item === event.item.data);
    const currentIndex = event.currentIndex;

    const movedItem = this.reOrderArr.splice(prevIndex, 1)[0];
    this.reOrderArr.splice(currentIndex, 0, movedItem);
  }


  drop(event: CdkDragDrop<string[]>) {
    console.log(
      'this.movies, event.previousIndex, event.currentIndex',
      this.movies,
      event.previousIndex,
      event.currentIndex
    );
    moveItemInArray(this.movies, event.previousIndex, event.currentIndex);
  }
  reOrderGroup(grp) {
   let final = this.finalizedData.filter(val => val.routeID == grp.routeID)
   console.log(final)
    this.reOrderArr = JSON.parse(JSON.stringify(final[0].empInfo));
  }
}
